import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import { api } from "../lib/api";

// Cascading dropdown for the "Produkty" nav item.
export function CategoriesDropdown({ label = "Produkty", testId = "nav-products-dropdown" }) {
  const [tree, setTree] = useState([]);
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState({}); // path -> bool by id
  useEffect(() => { api.get("/categories").then((r) => setTree(r.data)); }, []);

  function renderItems(nodes, depth) {
    return nodes.map((cat) => {
      const hasKids = (cat.children || []).length > 0;
      const isHover = !!hovered[cat.id];
      return (
        <div
          key={cat.id}
          className="relative"
          onMouseEnter={() => setHovered((h) => ({ ...h, [cat.id]: true }))}
          onMouseLeave={() => setHovered((h) => ({ ...h, [cat.id]: false }))}
        >
          <Link
            to={`/produkty/kategorie/${cat.slug}`}
            className="flex items-center justify-between gap-3 px-4 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-50 hover:text-blue-600 transition-colors"
            data-testid={`catmenu-${cat.slug}`}
          >
            <span>{cat.icon ? `${cat.icon} ` : ""}{cat.name}</span>
            {hasKids ? <ChevronRight className="w-3.5 h-3.5 text-zinc-400"/> : null}
          </Link>
          {isHover && hasKids ? (
            <div className="absolute left-full top-0 pl-1 z-50">
              <div className="glass-dropdown py-2 min-w-[220px]">
                {renderItems(cat.children, depth + 1)}
              </div>
            </div>
          ) : null}
        </div>
      );
    });
  }

  return (
    <div className="relative" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-testid={testId}>
      <Link to="/produkty" className="text-sm font-medium text-zinc-700 hover:text-blue-600 transition-colors inline-flex items-center gap-1" data-testid="nav-products">
        {label}
        {tree.length > 0 ? <ChevronDown className="w-3.5 h-3.5"/> : null}
      </Link>
      {open && tree.length > 0 ? (
        <div className="absolute left-0 top-full pt-2 z-50" data-testid="cat-menu-root">
          <div className="glass-dropdown py-2 min-w-[240px]">
            {renderItems(tree, 0)}
          </div>
        </div>
      ) : null}
    </div>
  );
}

// Mobile menu version — single accordion
export function MobileCategoryMenu({ onNavigate }) {
  const [tree, setTree] = useState([]);
  const [open, setOpen] = useState({});
  useEffect(() => { api.get("/categories").then((r) => setTree(r.data)); }, []);

  function renderNodes(nodes, depth) {
    return nodes.map((c) => {
      const hasKids = (c.children || []).length > 0;
      return (
        <div key={c.id}>
          <div className="flex items-center" style={{ paddingLeft: `${depth * 16}px` }}>
            <Link to={`/produkty/kategorie/${c.slug}`} onClick={onNavigate} className="flex-1 py-2 text-sm font-medium" data-testid={`mobile-cat-${c.slug}`}>
              {c.icon ? `${c.icon} ` : ""}{c.name}
            </Link>
            {hasKids ? (
              <button onClick={() => setOpen((o) => ({ ...o, [c.id]: !o[c.id] }))} className="p-2" data-testid={`mobile-cat-toggle-${c.slug}`}>
                {open[c.id] ? <ChevronDown className="w-4 h-4"/> : <ChevronRight className="w-4 h-4"/>}
              </button>
            ) : null}
          </div>
          {open[c.id] && hasKids ? renderNodes(c.children, depth + 1) : null}
        </div>
      );
    });
  }

  if (tree.length === 0) return null;
  return <div className="border-l-2 border-zinc-100 ml-3 pl-2">{renderNodes(tree, 0)}</div>;
}
